import { connectDeep } from 'redux-utils';

import { enableOsPermission } from 'actions/gallery';
import App from '../../../models/app';
export { useAbstractEditor } from './AbstractEditor';
export { default as List } from './List';
import { GalleryAppPermissions } from './types';

const mapStateToProps = (state: any, { app }: { app: App }) => {
  const {
    gallery: { osPermissions }
  } = state;

  const { grantedPermissions, requestedPermissions } = app;

  const permissions: GalleryAppPermissions = {};
  for (const permission of requestedPermissions) {
    // False by default if not already set
    permissions[permission] = grantedPermissions[permission] === true;
  }

  // Set OS permissions to off if denied for Fitbit iOS/Android
  const osPermissionsMap = app.osPermissionsEnableableMap;

  for (const permission in osPermissionsMap) {
    if (osPermissionsMap[permission]) {
      permissions[permission] = false;
    }
  }

  return {
    osPermissions,
    permissions
  };
};

const mapDispatchToProps = (dispatch: any, { app }: { app: App }) => ({
  enableOsPermission: (permissionType: string) =>
    dispatch(
      enableOsPermission(permissionType, {
        appName: app.name
      })
    )
});

export const connect = (component: any) =>
  connectDeep(mapStateToProps, mapDispatchToProps)(component);
